import React from 'react';
import { Row } from 'react-bootstrap';
import classes from './style.module.css'
import {APP_DISPLAY_NAME, APP_VERSION, COPYRIGHT_TEXT} from "../../constants/Constants"

const BottomRow = (props) => {
    return (
        <Row className={classes.BottomRow}>
            <div><span>{COPYRIGHT_TEXT + " " + APP_DISPLAY_NAME + " " + APP_VERSION}</span></div>
        </Row>
    )
}

export default BottomRow;